const Images = {
  COURSE1: require("../assets/images/Home/course1.png"),
  COURSE2: require("../assets/images/Home/course2.png"),
  COURSE3: require("../assets/images/Home/course3.png"),
  COURSE4: require("../assets/images/Home/course4.png"),
  FLOATIMG1: require("../assets/images/HeroSection/books.png"),
  FLOATIMG: require("../assets/images/HeroSection/img1234.png"),
  LANDING: require("../assets/images/HeroSection/hero.png"),
  FEATURE1: require("../assets/images/courseCard/c1.png"),
  FEATURE2: require("../assets/images/courseCard/c2.png"),
  FEATURE3: require("../assets/images/courseCard/c3.png"),
  PROMO: require("../assets/images/Promo/promo.mp4"),
  STAR: require("../assets/images/courseCard/star.png"),
  HALFSTAR: require("../assets/images/courseCard/halfStar.png"),
  READBOOK: require("../assets/images/category/readBook.png"),
  PENCILKID: require("../assets/images/category/pencilKid.png"),
  FLYINGBOOK: require("../assets/images/category/flyingBook.png"),
  APPBTN: require("../assets/images/Footer/appBtn.png"),
  FACEBOOK: require("../assets/images/Footer/fb.svg"),
  TWITTER: require("../assets/images/Footer/twitter.svg"),
  INSTAGRAM: require("../assets/images/Footer/insta.svg"),
  PLANET: require("../assets/images/Promo/Frame-2.png"),
  ALPHABET: require("../assets/images/Promo/Frame.png"),
  PENCIL: require("../assets/images/Promo/Frame-1.png"),
  SYM1: require("../assets/images/Promo/sym1.jpeg"),
  SYM2: require("../assets/images/Promo/sym2.jpeg"),
  SYM3: require("../assets/images/Promo/sym3.jpeg"),
  SYM4: require("../assets/images/Promo/sym4.jpeg"),
  PAPERROCKET: require("../assets/images/Promo/Frame.svg"),
  COLORSTARS: require("../assets/images/Promo/shape-4.png"),
  MULTISTARS: require("../assets/images/Promo/Star.png"),
  BLUESTAR: require("../assets/images/Promo/blueStar.svg"),
  PROFILE: require("../assets/images/HeroSection/stelly-orange.svg"),
  BRONE: require("../assets/images/reward/Bronze Medal.png"),
  SILVER: require("../assets/images/reward/Silver Medal.png"),
  GOLD: require("../assets/images/reward/Gold Medal.png"),
  PLAYCIRCLE: require("../assets/images/coursedetails/PlayCircle.svg"),
  FORWARDARROW: require("../assets/images/coursedetails/forwardArrow.svg"),
  ALERT: require("../assets/images/coursedetails/alert.svg"),
  GLOBE: require("../assets/images/coursedetails/Globe.svg"),
  BRONZE_BADGE: require("../assets/images/Badge/Bronze.png"),
  SILVER_BADGE: require("../assets/images/Badge/Silver.png"),
  GOLD_BADGE: require("../assets/images/Badge/Badge.png"),
  BADGE: require("../assets/images/reward/star.png"),
  TICK: require("../assets/images/tick.png"),
  USER: require("../assets/images/Promo/reviewer2.jpg"),
  LOGIN_LOGO: require("../assets/images/Admin/kraysLogoNoBg.png"),
  //Version 2.0
  NEETIE_LOGO: require("../assets/images/Nav/neetieLogo.png"),
  SEARCH_ICON: require("../assets/images/Nav/search.svg"),
  HEART: require("../assets/images/Nav/heart.svg"),
  BAG: require("../assets/images/Nav/bag.svg"),
  GROUP3: require("../assets/images/Nav/group3.svg"),
  RECTANGLE: require("../assets/images/Nav/rectangle.svg"),
  CANCEL: require("../assets/images/Nav/cancel.svg"),
  USERPROILE: require("../assets/images/Nav/user.jpg"),
  BACKGROUND: require("../assets/images/Home/background.png"),
  CURVEDLINE: require("../assets/images/Home/yellowCurvedLine.png"),
  PLANT: require("../assets/images/Home/plant.png"),
  TARGET: require("../assets/images/Home/target.png"),
  HANDSHAKE: require("../assets/images/Home/handshake.png"),
  FLOWERPOT: require("../assets/images/Home/flowerPot.svg"),
  GREENTICKCIRCLE: require("../assets/images/Promo/greenTickCircle.png"),
  GREENRECTANGLE: require("../assets/images/Promo/greenRectangle.svg"),
  RIGHTSIDEDOUBLEARROW: require("../assets/images/Promo/rightSideDoubleArrow.png"),
  RIGHTSIDEGREENDOUBLEARROW: require("../assets/images/Promo/rightSideGreenDoubleArrow.svg"),
  //CourseCard
  PROGRAM: require("../assets/images/courseCard/program.webp"),
  MEDICAL: require("../assets/images/courseCard/medical.jpeg"),
  AI: require("../assets/images/courseCard/AI.jpeg"),
  WEBDESIGN: require("../assets/images/courseCard/web.jpeg"),
  BOLDSTAR: require("../assets/images/courseCard/star.svg"),
  EMPTYSTAR: require("../assets/images/courseCard/emptyStar.svg"),

  LITEPINKBG: require("../assets/images/FeatureCourse/litePinkBg.svg"),
  LITEGREENBG: require("../assets/images/FeatureCourse/liteGreenBg.svg"),
  LITEBLURBG: require("../assets/images/FeatureCourse/liteBlueBg.svg"),
  LITEVIOLETBG: require("../assets/images/FeatureCourse/liteVioletBG.svg"),
  PINKRECTANGLE: require("../assets/images/FeatureCourse/pinkRectangle.svg"),
  VIOLETRECTANGLE: require("../assets/images/FeatureCourse/violetRectangle.svg"),
  DARKBLUERECTANGLE: require("../assets/images/FeatureCourse/darkBlueRectangle.svg"),
  LITEGREENRECTANGLE: require("../assets/images/FeatureCourse/greenRectangle.svg"),
  PEN: require("../assets/images/FeatureCourse/pen.svg"),
  PLAYSTORE: require("../assets/images/Footer/playStore.svg"),
  APPSTORE: require("../assets/images/Footer/appStore.svg"),
  WHATSAPP: require("../assets/images/Footer/whatsapp.svg"),
  APPLE: require("../assets/images/Home/apple.svg"),
  BEEN: require("../assets/images/Home/been.svg"),
  CLICKHERE: require("../assets/images/Home/Click Here.svg"),
  BORDER: require("../assets/images/Home/border.svg"),
  PRESS: require("../assets/images/Home/Press.svg"),
  BOLDDOWNARROW: require("../assets/images/Home/BoldDownArrow.svg"),
  ARROW: require("../assets/images/Home/Arrow.svg"),
  FLOWERMUD: require("../assets/images/Home/flowerMud.svg"),
  FLOWERPOTBG: require("../assets/images/Home/FlowerpotBg.svg"),
  WHITECURVEDLINE: require("../assets/images/Home/whiteCurveLine.svg"),
  LAPTOP: require("../assets/images/Promo/laptop.png"),
  PLAYICON: require("../assets/images/Promo/playIcon.svg"),
  PLAYICONBG: require("../assets/images/Promo/playIconBG.svg"),
  VIDEOIMAGE: require("../assets/images/Promo/videoImage.png"),
  TREE: require("../assets/images/FeatureCourse/tree.svg"),
  GREENSPINLINE: require("../assets/images/FeatureCourse/greenSpinLine.svg"),
  YELLOWSMALLCURVELINE: require("../assets/images/FeatureCourse/yellowSmallCurveLine.svg"),
  NEETIELOGO: require("../assets/images/Footer/NeetieLogo.png"),
  BORDERBOOK: require("../assets/images/Home/borderBook.svg"),
  BORDERTREE: require("../assets/images/Home/borderTree.svg"),
  BORDERLEAF: require("../assets/images/Home/borderLeaf.svg"),
  RIGHTSIDEARROW: require("../assets/images/Home/rightSideArrow.svg"),
  LEFTSIDEARROW: require("../assets/images/Home/leftSideArrow.svg"),
  DOWNARROW: require("../assets/images/Footer/downArrow.svg"),
  WHITETRIANGLE: require("../assets/images/Footer/whiteTriangle.svg"),
  SMALLPLAYICON: require("../assets/images/courseCard/smallPlayIcon.svg"),
  NOTEICON: require("../assets/images/courseCard/OutlinePaper.svg"),
  LINE: require("../assets/images/courseCard/Line.svg"),
  LEADERBOARDICON: require("../assets/images/LeaderBoard/rankIcon.svg"),
  CLOSE: require("../assets/images/LeaderBoard/close.svg"),
  GOLDMEDAL: require("../assets/images/Badge/goldMedal.svg"),
  SILVERMEDAL: require("../assets/images/Badge/silverMedal.svg"),
  BRONZEMEDAL: require("../assets/images/Badge/bronzeMedal.svg"),
  STUDENT: require("../assets/images/LeaderBoard/studentprofile.png"),
  STARBADGE: require("../assets/images/LeaderBoard/greenColorStarBadge.svg"),
  GREENBOOK: require("../assets/images/coursedetails/GreenBook.svg"),
  AUTHOR: require("../assets/images/coursedetails/neetie.jpeg"),
  COURSEIMAGE: require("../assets/images/courseCard/CourseImage.png"),
  DESCRIPTION: require("../assets/images/coursedetails/Description.svg"),
  WHAT_LEARN: require("../assets/images/coursedetails/WhatYouLearn.svg"),
  REQUIREMENT: require("../assets/images/coursedetails/Requirements.svg"),
  DESCRIPTION_ICON: require("../assets/images/coursedetails/DescriptionIcon.svg"),
  WHAT_LEARN_ICON: require("../assets/images/coursedetails/WhatLearnIcon.svg"),
  REQUIREMENT_ICON: require("../assets/images/coursedetails/RequirementIcon.svg"),
  WHITE_BG: require("../assets/images/coursedetails/WhiteBg.svg"),
  BLUE_RIGHT_ARROW: require("../assets/images/coursedetails/BlueRightArrow.svg"),
  BLUE_LEFT_ARROW: require("../assets/images/coursedetails/BlueLeftArrow.svg"),
  SECTION_TOGGLE: require("../assets/images/coursedetails/SectionToggle.svg"),
  FILTER: require("../assets/images/OurCourses/Filter.svg"),
  SORT: require("../assets/images/OurCourses/sort.svg"),
  GREENRIGHTSIDEARROW: require("../assets/images/OurCourses/greenRightSideArrow.svg"),
  BLUERIGHTARROW: require("../assets/images/OurCourses/blueRIghtArrow.svg"),
  BLUELEFTARROW: require("../assets/images/OurCourses/blueleftArrow.svg"),
  MSGBOX: require("../assets/images/LeaderBoard/msgBox.svg"),
  CART_BACK_ICON: require("../assets/images/MyCart/CartBackIcon.svg"),
  CART_DELETE: require("../assets/images/MyCart/CartDelete.svg"),
  BORDERCAP: require("../assets/images/Home/borderCap.svg"),
  // LOADER: require("../assets/animation/Loader/loader.json"),horizontalLine
  HORIZONTAL_LINE: require("../assets/images/Home/horizontalLine.svg"),
  LOGIN: require("../assets/images/Login/Login.svg"),
  LOGINTICK: require("../assets/images/Login/LoginTick.svg"),
  GREENBAR: require("../assets/images/Login/Greenbar.svg"),
  MYLEARNING: require("../assets/images/MyLearnings/Mylearnings.svg"),
  LEADERBOARD_ICON: require("../assets/images/LeaderBoard/LeaderBoardIcon.svg"),
  DASHBOARD_ICON: require("../assets/images/DashBoard/DashBoardIcon.svg"),
  LOGOUT: require("../assets/images/Logout.svg"),
  PHOTO: require("../assets/images/Home/photo.svg"),
  DROPDOWNARROW: require("../assets/images/Home/dropDownArrow.svg"),
  EYE: require("../assets/images/Home/eyeIcon.svg"),
  REPLACE: require("../assets/images/Home/replace.svg"),
  REMOVE: require("../assets/images/Home/remove.svg"),
  // Sidebar Icons
  GROUPS_ICON: require("../assets/images/DashBoard/Groups.svg"),
  CHAPTER_ICON: require("../assets/images/DashBoard/ChapterCourse.svg"),
  EDIT: require("../assets/images/Home/edit.svg"),
  SCHOOL: require("../assets/images/DashBoard/school.svg"),
  USERS: require("../assets/images/DashBoard/users.svg"),
  COURSES: require("../assets/images/DashBoard/courses.svg"),
  AUTHORS: require("../assets/images/DashBoard/author.svg"),
  LOGO: require("../assets/images/Login/logo.png"),
  LOGINCHECK: require("../assets/images/Login/LoginCheck.svg"),
  EDIT_COURSE: require("../assets/images/DashBoard/EditCourse.svg"),
  DELETE: require("../assets/images/DashBoard/delete.svg"),
  UPLOADVIDEO: require("../assets/images/DashBoard/uploadVideo.svg"),
  CLEAR: require("../assets/images/DashBoard/clear.svg"),
  UPLOADFILE: require("../assets/images/DashBoard/fileUpload.svg"),

  NAVIGATION_ICON: require("../assets/images/coursedetails/NavigationIcon.svg"),
  LEFTSIDEDOUBLE_ARROW: require("../assets/images/LeftSideDoubleArrow.svg"),
  CONTACT: require("../assets/images/ContactUs.svg"),
  Mission: require("../assets/images/Mission.svg"),
  Vision: require("../assets/images/Vision.svg"),
  AboutUs: require("../assets/images/Aboutus.jpeg"),
  FAQS: require("../assets/images/faqs.svg"),
  IMAGEONE: require("../assets/images/image1.jpg"),
  IMAGETWO: require("../assets/images/image2.jpg"),
  IMAGETHREE: require("../assets/images/image3.jpg"),
  DIGITALIMAGE: require("../assets/images/digital.png"),
  LANDINGIMAGE: require("../assets/images/landing.jpg"),
  DIGITALSIGNUP: require("../assets/images/digitalsignup.png"),
};
export default Images;
